import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import angularFilter from 'angular-filter';
import Common from './common/common';
import Modules from './modules';
import appUI from './ui';
import 'normalize.css';
import '../assets/css/AdminLTE.css';
import '../assets/css/skin-blue.css';
import '../assets/css/bootstrap-v-tabs.css';
import '../assets/css/style.css';
import uiSelect from 'ui-select';
import authLayoutTemplate from './common/auth/auth.html';
import appLayout from './common/layout.html';
import 'ui-select/dist/select.css'
import loaderBar from 'angular-loading-bar';
console.log(loaderBar);
angular.module('app', [
  uiRouter,
  Common,
  Modules,
  appUI,
  'ngStorage',
  uiBootstrap,
  angularFilter,
  uiSelect,
  loaderBar
])
  // .constant("APPLICATION_URL", 'http://localhost:8000')
  // .constant("API_URL", 'http://localhost:4000')
  .constant("APPLICATION_URL", 'https://signlabs.se')
  .constant("API_URL", 'http://46.101.182.153:4000')
  
  // Pacsoft ==> Unifaun
 .constant("UNIFAUN_ID", 'N4N5DFXWY7HNGAVI')
 .constant("UNIFAUN_SECRET", 'DQMJEM5ORXAPXIJR2XZC2WJC')
 
  // Unifaun Test Account
  // .constant("UNIFAUN_ID", 'ZRIUPEMMDWR656B7')
  // .constant("UNIFAUN_SECRET", 'ZAKOJ6ALCA5JED5WSUCAEY6U')
  
  .config(($locationProvider, $stateProvider, $urlRouterProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');

    $stateProvider.state('auth', {
      url: '/auth',
      abstract: true,
      template: authLayoutTemplate
    });
    $stateProvider.state('auth.login', {
      url: '/login',
      template: '<loginform>',
      data: {
        noLogin: true
      }
    });

    $stateProvider.state('app', {
      template: appLayout,
      url: '/',
      resolve: {
        data: (ProductsDataProvider, ProductPartsDataProvider, $q) => {
          "ngInject"
          return $q.all([
            ProductsDataProvider.loadProducts(),
            ProductPartsDataProvider.loadShapes(),
            ProductPartsDataProvider.loadColors(),
            ProductPartsDataProvider.loadFixmethods()
          ])

        }
      },
      controller($scope, data, AuthService, $state) {
        $scope.products = data[0];
        $scope.logout = function ($event) {
          $event.preventDefault();
          AuthService.logout();
          $state.go('auth.login');
        }
      }

    });

    $urlRouterProvider.otherwise(function ($injector, $location) {
      var $state = $injector.get("$state");
      $state.go("app");
    });

  })
  .run(function ($rootScope, $state, AuthService) {
    "ngInject"
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, fromState) {
      //return;
      if (!('data' in next) || true !== next.data.noLogin) {
        if (!AuthService.getCurrentUser()) {
          event.preventDefault();
          $state.go('auth.login');
        }
      }

    });
  });


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/app.js
 **/